import styled, { css } from 'styled-components'

export const Label = styled.label`
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  flex: ${({ flexWeight = 1 }) => flexWeight};
  display: flex;
  flex-direction: column;
`

export const Button = styled.button`
  outline-color: #002d63;
  width: 100%;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
  ${({ maxWidth }) => maxWidth && css`max-width: ${maxWidth}`};
`

export const Span = styled.span`
  line-height: 28px;
`
